/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-classes-per-file */
import {
  SearchSuggestionsRequest,
  SalesChannel,
  ProductSearchRequest,
  ProductFilter,
  SizeFilterSizeUnit,
  SizeFilter,
  ProductCondition,
} from '@goatapp/protos-gen-node/buying/consumer_search/api/v1/server_pb';

export const getPricesRanges = (ranges: string[]): number[] => {
  if (!ranges || ranges.length === 0) {
    return undefined;
  }
  const newranges = [];
  for (const range of ranges) {
    const [lowStr, highStr] = range.split('-');

    const low = Number.parseInt(lowStr, 10);
    const high = highStr === 'inf' ? 1000000000000 : Number.parseInt(highStr, 10);

    newranges.push(low, high);
  }

  return newranges;
};

export type IConsumerSearchParams = {
  salesChannels: SalesChannel[];
  term: string;
  pageOffset: number;
  productLimit: number;
};

export type IProductFilter = {
  categories: string[];
  activities: string[];
  releaseYears: string[];
  brands: string[];
  colors: string[];
  genders: string[];
  releaseDateStart: string[];
  releaseDateEnd: string[];
  productTypes: string[];
  sizes: string[];
  conditions: string[];
  sale?: boolean;
};

export const size_type: any = {
  shoes: 1,
  sneakers: 1,
  tops: 2,
  bottoms: 3,
  outerwear: 4,
  dresses: 5,
  belts: 6,
};

export const size_gender: any = {
  MEN: 1,
  WOMEN: 2,
  YOUTH: 3,
  INFANT: 4,
};

export const size_unit = {
  US: 1,
  UK: 2,
  IT: 3,
  FR: 4,
  EU: 5,
  JP: 6,
  UNIVERSAL: 7,
};

export const VALUE_TO_NAME_PRODUCT_CONDITION_MAP = {
  1: 'new_no_defects',
  2: 'new_with_defects',
  3: 'used',
  4: 'goat_clean',
};
export const PRODUCT_CONDITION_MAP: any = {
  new_no_defects: {
    name: 'New',
    value: ProductCondition.NEW_NO_DEFECTS,
    key: 'new_no_defects',
  },
  new_with_defects: {
    name: 'New with Defect',
    value: ProductCondition.NEW_WITH_DEFECTS,
    key: 'new_with_defects',
  },
  goat_clean: {
    name: 'GOAT Clean',
    value: ProductCondition.GOAT_CLEAN,
    key: 'goat_clean',
  },
  used: {
    name: 'Used',
    value: ProductCondition.USED,
    key: 'used',
  },
};

export type IProductSearchParams = ProductSearchRequest.AsObject & {
  req?: any;
  sale?: any;
  availableNow?: any;
  priceRangeCentsList?: any;
  cookies?: any;
};
export class ConsumerSearchRequester extends SearchSuggestionsRequest {
  constructor(params: IConsumerSearchParams) {
    super();

    this.set(params);
  }

  private set = (params: IConsumerSearchParams) => {
    const { salesChannels, pageOffset, term, productLimit } = params;
    this.setSalesChannelsList(salesChannels);
    this.setQueryString(term);
    this.setPageLimit(pageOffset);
    this.setProductLimit(productLimit || 25);
  };
}

export class ProductFilterRequester extends ProductFilter {
  constructor(params: IProductFilter) {
    super();
    this.set(params);
  }
  private set = (params: IProductFilter) => {
    const {
      categories = [],
      colors = [],
      brands = [],
      genders = [],
      releaseYears = [],
      releaseDateStart = [],
      releaseDateEnd = [],
      productTypes = [],
      activities = [],
      conditions = [],
      sizes = [],
      sale,
    } = params;

    this.setColorsList(colors);
    this.setBrandsList(brands);
    this.setGendersList(genders);
    if (sale) {
      this.setCategoriesList(['apparel', 'miscellaneous', 'space']);
    } else {
      this.setCategoriesList(categories);
    }

    this.setActivitiesList(activities);
    if (releaseYears.length > 0) {
      this.setReleaseYearsList(releaseYears);
    } else if (releaseDateStart.length > 0 && releaseDateEnd.length > 0) {
      this.setReleaseDateStart(releaseDateStart[0]);
      this.setReleaseDateEnd(releaseDateEnd[0]);
    }
    this.setProductTypesList(productTypes);

    if (conditions.length > 0) {
      this.setProductConditionsList(conditions.map((condt) => PRODUCT_CONDITION_MAP[condt]?.value));
    }

    if (sizes.length > 0) {
      const s: any = sizes
        .map((siz: any) => {
          const [unit, type, gender, value] = (siz || '').trim().split('_');

          if (type.length > 0 && value.length > 0) {
            const myS = new SizeFilter();

            myS.setGender(size_gender[gender.toUpperCase()]);
            myS.setSizeUnit(size_unit[unit.toUpperCase()]);
            myS.setProductType(size_type[type]);
            myS.setSize(value.toUpperCase());

            return myS;
          }
          return '';
        })
        .filter((i) => i);

      this.setSizesList(s);
    }
  };
}
export class ProductSearchRequester extends ProductSearchRequest {
  constructor(params: IProductSearchParams) {
    super();

    this.set(params);
  }

  private set = (params: IProductSearchParams) => {
    const {
      salesChannelId,
      queryString,
      sortType,
      pageLimit,
      pageNumber,
      includeAggregations,
      productFilter,
      collectionSlug,
      priceCentsMin,
      priceCentsMax,
      includeVariants,
      instantShip,
      availableNow,
      priceRangeCentsList,
      sale,
      underRetail,
    } = params;

    this.setQueryString(queryString);
    this.setSalesChannelId(salesChannelId);
    this.setCollectionSlug(collectionSlug || '');
    // this.setProductFilter(value?: ProductFilter);
    this.setSortType(sortType || 1);
    this.setSearchAfterProductId('');
    this.setPageLimit(pageLimit);
    this.setPageNumber(pageNumber);
    this.setIncludeAggregations(includeAggregations || false);
    this.setIncludeVariantAggregations(includeAggregations || false);
    this.setIncludeVariants(includeVariants || false);

    if (underRetail === true) {
      this.setUnderRetail(underRetail);
    }
    if (instantShip === true) {
      this.setInstantShip(instantShip);
    }

    const sizeUnits = [
      SizeFilterSizeUnit.SIZE_FILTER_SIZE_UNIT_EU,
      SizeFilterSizeUnit.SIZE_FILTER_SIZE_UNIT_FR,
      SizeFilterSizeUnit.SIZE_FILTER_SIZE_UNIT_IT,
      SizeFilterSizeUnit.SIZE_FILTER_SIZE_UNIT_JP,
      SizeFilterSizeUnit.SIZE_FILTER_SIZE_UNIT_UK,
      SizeFilterSizeUnit.SIZE_FILTER_SIZE_UNIT_UNIVERSAL,
      SizeFilterSizeUnit.SIZE_FILTER_SIZE_UNIT_US,
    ];

    this.setAggregationSizeUnitsList(sizeUnits);

    if (sale) {
      this.setUnderRetail(true);
    }

    // if we have a range no need to use min and max
    if (priceRangeCentsList && priceRangeCentsList.length > 0) {
      const priceRanges = getPricesRanges(priceRangeCentsList as string[]);

      if (priceRanges) {
        this.setPriceRangeCentsList(priceRanges);
      }
    } else if (priceCentsMax || priceCentsMax) {
      this.setPriceRangeCentsList([]);
      if (priceCentsMin) {
        this.setPriceCentsMin(priceCentsMin);
      }
      if (priceCentsMax) {
        this.setPriceCentsMax(priceCentsMax);
      }

      if (availableNow && !priceCentsMax) {
        this.setPriceCentsMax(100000000000);
      }
    }

    if (productFilter) {
      const productFilterRequester = new ProductFilterRequester({
        ...(JSON.parse(productFilter as unknown as string) as IProductFilter),
        sale,
      });
      this.setProductFilter(productFilterRequester);
    }
  };
}
